import React from 'react';

const SearchButton = ({ children, onGetSuggestion }) => {
    const getItemValue = (e) => {
        const buttonText = e.currentTarget.innerHTML;
        onGetSuggestion(buttonText);
    };
    return (
        <div className="button-container">
            <button
                className="button button--light-bg search-suggestion__buttons"
                type="button"
                onClick={getItemValue}
            >
                {children}
            </button>
        </div>
    );
};

export default SearchButton;
